export default __webpack_public_path__ + "assets/world.e3d367dd.svg";